import React from 'react';
import NowLine from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/now';

export const TimelineSubheader = () => <NowLine />;
